
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SupportIssueNotListed',
  props: {
    supportTier: {
      type: String,
      required: true
    }
  }
})
